<template>
    <div class="ml-auto color_section">
        <div class="row">
            <div class="col-md-10 col-lg-12 color_checkbox_col">
                <div
                    class="d-flex flex-wrap justify-content-left color_checkbox"
                >
                    <div
                        class="form-check pl-0"
                        v-for="(color, ind) in colorsList"
                        :key="ind"
                    >
                        <!-- First Colors -->
                        <a
                            v-tooltip="color.name"
                            v-show="ind < colors_limit"
                            href="javascript:void(0)"
                            class="color_circle mr_6"
                            :style="
                                color.swatches
                                    ? 'background-image:url(' +
                                      color.swatches +
                                      ')'
                                    : 'background-color:' + color.hex
                            "
                        ></a>
                        <!-- More Colors -->
                        <div v-if="is_color_show_more">
                            <a
                                v-tooltip="color.name"
                                v-show="ind >= colors_limit"
                                href="javascript:void(0)"
                                class="color_circle mr_6"
                                :style="
                                    color.swatches
                                        ? 'background-image:url(' +
                                          color.swatches +
                                          ')'
                                        : 'background-color:' + color.hex
                                "
                            ></a>
                        </div>
                    </div>

                    <div
                        v-show="colorsList.length > colors_limit"
                        class="form-check pl-0"
                    >
                        <label>
                            <input
                                type="checkbox"
                                @click="showMore('is_color_show_more')"
                            />
                            <span
                                class="checkmark check_box plus_icon-align"
                                v-bind:class="
                                    is_color_show_more ? 'minus_box' : ''
                                "
                            >
                                <img
                                    v-if="is_color_show_more"
                                    src="/maincss/images/minus1.svg"
                                />
                                <span v-else
                                    >+{{ colorsList.length - colors_limit }}</span
                                >
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductColors",
    props: {
        colors: {
            required: true
        }
    },
    data() {
        return {
            is_color_show_more: false,
            colors_limit: 10
        };
    },
    computed: {
        colorsList() {
            return this.colors && Array.isArray(this.colors) ? this.colors : [];
        }
    },
    methods: {
        productColors(colors) {
            let grouped_colors = this.groupBy(colors, "color_id");
            let colors_list = [];
            Object.values(grouped_colors).forEach((items) => {
                if (items.length > 0 && items[0].Color) {
                    colors_list.push(items[0].Color);
                }
            });
            return colors_list;
        },
        groupBy(xs, key) {
            return xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        },
        showMore(list) {
            var _this = this;
            _this[list] = _this[list] ? false : true;
        }
    }
};
</script>
